module.exports = __webpack_public_path__ + "media/alarm.5c0b3ece.mp3";